import { makeFetchTransport } from '@sentry/browser';
import type { BaseTransportOptions, Transport } from '@sentry/core';

const POLL_INTERVAL_MS = 30_000;

let tunnelEnabled = false;

/**
 * Consulta o endpoint que indica se o tunnel do Sentry está habilitado.
 * Em caso de falha, mantém o último estado conhecido para que os eventos
 * continuem sendo enviados diretamente ao Sentry.
 */
async function refreshTunnelState(enabledUrl: string): Promise<void> {
  try {
    const response = await fetch(enabledUrl);
    if (!response.ok) return;
    tunnelEnabled = (await response.json()) === true;
  } catch {
    // mantém o último estado conhecido; em caso de falha os envelopes seguem direto para o Sentry
  }
}

export function startSentryTunnelPolling(enabledUrl: string): void {
  if (!enabledUrl) return;
  void refreshTunnelState(enabledUrl);
  setInterval(() => void refreshTunnelState(enabledUrl), POLL_INTERVAL_MS);
}

export function makeSentryTunnelTransport(tunnelUrl: string) {
  return (options: BaseTransportOptions): Transport => {
    const direct = makeFetchTransport(options);
    if (!tunnelUrl) return direct;
    const tunneled = makeFetchTransport({ ...options, url: tunnelUrl });
    return {
      send: (envelope) => (tunnelEnabled ? tunneled : direct).send(envelope),
      flush: async (timeout) => {
        const [directOk, tunneledOk] = await Promise.all([
          direct.flush(timeout),
          tunneled.flush(timeout),
        ]);
        return directOk && tunneledOk;
      },
    };
  };
}
